import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	Button,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Card,
	CardBody,
	Badge,
	UncontrolledTooltip,
} from 'reactstrap';
import classnames from 'classnames';
import SelectComponent from '@componentes/select/select.component';
import SelectAsyncComponent from '@componentes/select/select-async.component';
import { acessoPermitido } from '../../../acessos.seguranca';
import WebapiCommon from '../util/webapi.common';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import { unionOptions } from '../util/api-common.util';
import './morfologia.styles.css';
import CheckBox from '../../../componentes/checkbox/checkbox.component';
import * as acessos from '../../../acessos.const.util';
import * as commonActions from '../common.action';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function MorfologiaContainer({ altura }) {

	const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
	const usuario = useSelector((state) => state.usuario);
	const detalhes = useSelector((state) => state.commonReducer.detalhes);
	const etapa = useSelector((state) => state.commonReducer.etapa);

	const [topografias, setTopografias] = useState([]);
	const [topografiaSelecionada, setTopografiaSelecionada] = useState(null);
	const [morfologiaSelecionada, setMorfologiaSelecionada] = useState(null);
	const [morfologiasTopografias, setMorfologiasTopografias] = useState([]);
	const [toggleTab, setToggleTab] = useState('1');
	const [marcarPrincipal, setMarcarPrincipal] = useState(false);
	const [medico, setMedico] = useState(0);
	const [anotacoes, setAnotacoes] = useState('');
	const [editarMorfoTopo, setEditarMorfoTopo] = useState(null);
	const [cidDigitado, setCIDDigitado] = useState('');

	const dispatch = useDispatch();

	useEffect(() => {
		let topografiasTemp = [];

		const requests = [
			WebapiCommon.getTopografiaPorLaudo(detalhes.laudo),
			WebapiCommon.getMedicos(),
			WebapiCommon.getCIDPorLaudo(detalhes.laudo),
		];

		if (detalhes.laudoAnterior && detalhes.laudoAnterior !== '0') {
			requests.push(WebapiCommon.getTopografiaPorLaudo(detalhes.laudoAnterior));
		}

		Promise.all(requests).then((result) => {
			const [positionZero] = result;
			topografiasTemp = positionZero;

			const usuarioLocal = getUsuarioLocalStorage();
			let ts = result[1].find(
				(user) => user.value === usuarioLocal.usuarioId
			);

			if (ts === 0 || ts == undefined || ts == null) {
				ts = result[1].find(
					(user) => user.label === detalhes.solicitante + ' - ' + detalhes.medico
				);
			}

			if (requests.length === 4) {
				topografiasTemp = unionOptions(result[0], result[3]);
			}

			const morfologiasTopografiasResult = result[2];

			morfologiasTopografias.find((x) => {
				if (x.cidPrincipal && x.cidPrincipal === true) {
					return x.cidPrincipal;
				}
				return false;
			});

			setMorfologiasTopografias(morfologiasTopografiasResult);
			setTopografias(topografiasTemp);
			setMedico(ts);
		});

		setMarcarPrincipal(false);
		setAnotacoes('');
	}, []);

	const gravarNovoCID = (checked, morfTop) => {
		const morfologiasTopografiasResult = morfologiasTopografias.map((mf) => {
			if (
				mf.idDiagnostico === morfTop.idDiagnostico &&
				mf.idTopografia === morfTop.idTopografia
			) {
				mf.cidPrincipal = checked;
			} else {
				mf.cidPrincipal = false;
			}

			return mf;
		});

		setMorfologiasTopografias(morfologiasTopografiasResult);

		WebapiCommon.updateCIDPrincipal(
			detalhes.laudo,
			morfTop.idDiagnostico,
			morfTop.idTopografia,
			checked
		);
	};

	const onChange = (type, item) => {
		if (type === 'morfologiaSelecionada') {
			setMorfologiaSelecionada(item);
		}

		if (type === 'topografiaSelecionada') {
			setTopografiaSelecionada(item);
		}
	};

	const resetState = () => {
		setMorfologiaSelecionada(null);
		setTopografiaSelecionada(null);
		setAnotacoes('');
		setMarcarPrincipal(false);
	};

	const alterarCID = (morfoTopo) => {
		setEditarMorfoTopo(morfoTopo);
		setTopografiaSelecionada({
			label: `${morfoTopo.codigoDiagnostico} - ${morfoTopo.topografia}`,
			value: morfoTopo.idTopografia,
		});
		setMorfologiaSelecionada({
			label: `${morfoTopo.idTopografia} - ${morfoTopo.morfologia}`,
			value: morfoTopo.idDiagnostico,
		});
		setToggleTab('3');
	};

	const salvarAlteracaoCID = () => {
		WebapiCommon.alterarCIDPorLaudo(
			detalhes.laudo,
			morfologiaSelecionada.value,
			topografiaSelecionada.value,
			editarMorfoTopo.idLaudoDiagnostico
		).then(() => {
			WebapiCommon.getCIDPorLaudo(detalhes.laudo)
				.then((result) => {
					setMorfologiasTopografias(result);
					dispatch(
						commonActions.showAlerta(
							'sucesso',
							'CID alterado com sucesso!',
							1500
						)
					);
				})
				.finally(() => {
					resetState();
					setToggleTab('2');
				});
		});
	};

	const excluirCID = (morfoTopo) => {
		WebapiCommon.apagarCIDporLaudo(
			detalhes.laudo,
			morfoTopo.idLaudoDiagnostico
		).then(() => {
			WebapiCommon.getCIDPorLaudo(detalhes.laudo)
				.then((result) => {
					setMorfologiasTopografias(result);
					dispatch(
						commonActions.showAlerta(
							'sucesso',
							'CID excluído com sucesso!',
							1500
						)
					);
				})
				.finally(() => resetState());
		});
	};

	const adicionarTopografiaMorfologia = () => {
		if (morfologiaSelecionada === null) {
			dispatch(commonActions.showAlerta('alerta', 'Informe o CID', 1500));
		} else if (topografiaSelecionada === null) {
			dispatch(
				commonActions.showAlerta('alerta', 'Informe uma topografia', 1500)
			);
		} else {
			const exist = morfologiasTopografias.find(
				(morf) =>
					morf.idDiagnostico === morfologiaSelecionada.value &&
					morf.idTopografia === topografiaSelecionada.value
			);

			if (exist) {
				dispatch(commonActions.showAlerta('alerta', 'CID já inserido!', 1500));
			} else {
				const payload = {
					pacienteId: parseInt(detalhes.pacienteId, 10),
					diagnosticoId: morfologiaSelecionada.value,
					topografiaId: topografiaSelecionada.value,
					anotacoes,
					medicoId: medico ? medico.value : medico,
					cidPrincipal: marcarPrincipal,
					etapa: etapa.etapa,
					laudo: detalhes.laudo,
				};

				WebapiCommon.adicionarMorfologia(payload).then(() => {
					WebapiCommon.getCIDPorLaudo(detalhes.laudo)
						.then((result) => {
							setMorfologiasTopografias(result);

							dispatch(
								commonActions.showAlerta(
									'sucesso',
									'CID cadastrado com sucesso!',
									1500
								)
							);
						})
						.finally(() => resetState());
				});
			}
		}
	};

	const obterCIDPorTermo = () =>
		new Promise((resolve) => {
			if (cidDigitado.length < 3) return;

			const request = [WebapiCommon.getMorfologiaPorTermo(cidDigitado)];
			Promise.all(request)
				.then((res) => {
					resolve(res[0]);
				})
				.catch((err) => {
					resolve(err);
				});
		});

	return (
		acessoPermitido(usuario, acessos.TopografiaMorfologia) &&
		acessoPermitido(usuario, acessos.Adicionar) && (
			<div className="mv-morfologias-container">
				<Nav tabs>
					<NavItem>
						<NavLink
							className={classnames({ active: toggleTab === '1' })}
							onClick={() => {
								setToggleTab('1');
							}}
						>
							<IntlMessage id = "dashboards.examDetail.adding"/>
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={classnames({ active: toggleTab === '2' })}
							onClick={() => {
								setToggleTab('2');
							}}
						>
							<IntlMessage id = "dashboards.examDetail.cidTopography"/>
							{morfologiasTopografias !== undefined &&
								morfologiasTopografias.length > 0 && (
									<Badge color="primary" pill className="mv-info-morfologia">
										{morfologiasTopografias.length}
									</Badge>
								)}
						</NavLink>
					</NavItem>
				</Nav>
				<br />
				<TabContent activeTab={toggleTab}>
					<TabPane tabId="1">
						<Row>
							<Col xl="8">
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.patient"/></Label>

									<span className="mv-info-morfologia">
										<p
											id={`paciente_${detalhes.laudo}`}
											style={{ fontSize: '14px', marginBottom: '2px' }}
										>
											<strong><IntlMessage id = "dashboards.examDetail.patient"/> </strong>
											{detalhes.paciente}
											<UncontrolledTooltip
												placement="top"
												target={`paciente_${detalhes.laudo}`}
											>
												{detalhes.paciente}
											</UncontrolledTooltip>
										</p>
										{detalhes.pacienteNomeSocial && (
											<p
												id={`nomesocial_${detalhes.laudo}`}
												style={{ fontSize: '14px', marginBottom: '2px' }}
											>
												<strong><IntlMessage id = "dashboards.examDetails.socialName"/></strong>
												{detalhes.pacienteNomeSocial}
												<UncontrolledTooltip
													placement="top"
													target={`nomesocial_${detalhes.laudo}`}
												>
													{detalhes.pacienteNomeSocial}
												</UncontrolledTooltip>
											</p>
										)}
									</span>
								</FormGroup>
							</Col>
							<Col xl="4">
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.date"/></Label>
									<span className="mv-info-morfologia">
										{detalhes.dataEntradaMaterial}
									</span>
								</FormGroup>
							</Col>
							<Col xl="8">
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.performingPhysician"/></Label>
									<span className="mv-info-morfologia">{detalhes.medico}</span>
								</FormGroup>
							</Col>
							<Col xl="4">
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.numberOfExam"/></Label>
									<span className="mv-info-morfologia">{detalhes.nrExame}</span>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.topography"/></Label>
									<SelectComponent
										options={topografias}
										value={topografiaSelecionada}
										onChange={(e) => onChange('topografiaSelecionada', e)}
										placeholder={translate("dashboards.examDetail.selectTopography")}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<div
										style={{ display: 'flex', justifyContent: 'space-between' }}
									>
										<Label><IntlMessage id = "dashboards.examDetail.CID"/></Label>
										{cidDigitado.length < 3 && (
											<span>
												<IntlMessage id = "dashboards.examDetail.enter"/> {3 - cidDigitado.length} <IntlMessage id = "dashboards.examDetail.searchCharacters"/>
											</span>
										)}
									</div>
									<SelectAsyncComponent
										cacheOptions
										defaultOptions
										height={24}
										defaultValue={{}}
										placeholder={translate("dashboards.examDetail.selectCID")}
										onInputChange={setCIDDigitado}
										loadOptions={obterCIDPorTermo}
										className="marginBottom"
										onChange={(e) => onChange('morfologiaSelecionada', e)}
										disabled={!topografiaSelecionada && true}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<CheckBox
										label={<IntlMessage id = "dashboards.examDetail.mainDiagnosis"/>}
										onChange={(e) => {
											setMarcarPrincipal(e.target.checked);
										}}
										checked={marcarPrincipal}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.annotations"/></Label>
									<Input
										type="textarea"
										name="text"
										onChange={(e) => {
											setAnotacoes(e.target.value);
										}}
										value={anotacoes}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Button
							color="primary"
							className="adicionar"
							onClick={adicionarTopografiaMorfologia}
							disabled={!morfologiaSelecionada}
						>
							<IntlMessage id = "dashboards.examDetail.adding"/>
						</Button>
					</TabPane>

					<TabPane tabId="2">
						<div
							style={{
								height: `${altura - 48}px`,
								width: '100%',
								overflowY: 'scroll',
								overflowX: 'hidden',
							}}
						>
							{morfologiasTopografias.map((morfoTopo, i) => (
								<Row key={i}>
									<Col>
										<Card>
											<CardBody>
												<Col style={{ float: 'left', width: '55%' }}>
													<Row>
														<Col sm="auto">
															<b><IntlMessage id = "dashboards.examDetail.CID"/></b>
															{` ${morfoTopo.codigoDiagnostico} - ${morfoTopo.morfologia}`}
														</Col>
													</Row>
													<Row>
														<Col sm="auto">
															<b><IntlMessage id = "dashboards.examDetail.topography"/></b>
															{` ${morfoTopo.codigoTopografia} - ${morfoTopo.topografia}`}
														</Col>
													</Row>
													{morfoTopo.anotacao && (
														<Row>
															<Col sm="auto">
																<b><IntlMessage id = "dashboards.examDetail.annotation"/></b>
																{` ${morfoTopo.anotacao}`}
															</Col>
														</Row>
													)}
												</Col>
												<Col style={{ float: 'left', width: '30%' }}>
													<CheckBox
														label={<IntlMessage id = "dashboards.examDetail.mainDiagnosis"/>}
														onChange={(e) => {
															gravarNovoCID(e.target.checked, morfoTopo);
														}}
														checked={morfoTopo.cidPrincipal}
													/>
												</Col>
												<Col className="acoes">
													<Button
														onClick={() => alterarCID(morfoTopo)}
														color="primary"
													>
														<i
															style={{ display: 'block' }}
															className="mv-basico-editar"
														/>
													</Button>
													<Button
														onClick={() => excluirCID(morfoTopo)}
														color="danger"
													>
														<i
															style={{ display: 'block' }}
															className="mv-basico-fechar"
														/>
													</Button>
												</Col>
											</CardBody>
										</Card>
									</Col>
								</Row>
							))}
						</div>
					</TabPane>

					<TabPane tabId="3">
						<Row>
							<Col>
								<FormGroup>
									<Label><IntlMessage id = "dashboards.examDetail.topography"/></Label>
									<SelectComponent
										options={topografias}
										value={topografiaSelecionada}
										onChange={(e) => onChange('topografiaSelecionada', e)}
										placeholder={translate("dashboards.examDetail.selectTopography")}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col>
								<FormGroup>
									<div
										style={{ display: 'flex', justifyContent: 'space-between' }}
									>
										<Label><IntlMessage id = "dashboards.examDetail.CID"/></Label>
										{cidDigitado.length < 3 && (
											<span>
												<IntlMessage id = "dashboards.examDetail.enter"/> {3 - cidDigitado.length} <IntlMessage id = "dashboards.examDetail.searchCharacters"/>
											</span>
										)}
									</div>
									<SelectAsyncComponent
										cacheOptions
										defaultOptions
										height={24}
										defaultValue={{}}
										placeholder={translate("dashboards.examDetail.selectCID")}
										onInputChange={setCIDDigitado}
										loadOptions={obterCIDPorTermo}
										className="marginBottom"
										onChange={(e) => onChange('morfologiaSelecionada', e)}
										disabled={!topografiaSelecionada && true}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Button
							color="primary"
							className="adicionar"
							onClick={
								toggleTab === '1'
									? adicionarTopografiaMorfologia
									: salvarAlteracaoCID
							}
							disabled={!morfologiaSelecionada}
						>
							<IntlMessage id = "dashboards.examDetail.toSave"/>
						</Button>
					</TabPane>
				</TabContent>
			</div>
		)
	);
}

const mapStateToProps = (state) => ({
	usuario: state.usuario,
	detalhes: state.commonReducer.detalhes,
	etapa: state.commonReducer.etapa,
});

export default connect(mapStateToProps)(MorfologiaContainer);



// WEBPACK FOOTER //
// ./src/app/common/morfologia/morfologia.container.jsx